import { Component, OnDestroy, OnInit } from '@angular/core';

import { featuresVideo } from 'src/app/configs/featuresCarousel';
import { LanguageService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { Step6Component } from './components/step6/step6.component';
import { Step5Component } from './components/step5/step5.component';
import { CarouselFeaturesComponent } from '../../../../shared/components/carousel-features/carousel-features.component';
import { Step3Component } from './components/step3/step3.component';
import { Step2Component } from './components/step2/step2.component';
import { Step1Component } from './components/step1/step1.component';
import { PromoteBannerComponent } from 'app/shared/components';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [
    PromoteBannerComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    CarouselFeaturesComponent,
    Step5Component,
    Step6Component,
  ],
})
export class HomeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  features = featuresVideo;
  currency = '';
  tabOfCarouselPartners = [];

  constructor(private languageService: LanguageService) {
    this.tabOfCarouselPartners = this.spreadDistance(
      this.tabOfCarouselPartners
    );
    this.tabOfCarouselPartners = this.tabOfCarouselPartners.map(
      (e) => `https://static.kinomap.com/manufacturer/${e}.png`
    );
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.languageService.currency.subscribe(
        (currency) => (this.currency = currency)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  spreadDistance(array) {
    let temp = [],
      count = {};

    for (let v of array) {
      if (!count[v]) count[v] = 0;
      if (!temp[count[v]]) temp[count[v]] = [];
      temp[count[v]].push(v);
      count[v]++;
    }
    return temp.flatMap((array) => array.sort((a, b) => count[b] - count[a]));
  }
}
